__turbopack_context__.v({
  "content": "_3tJKsG_content",
  "ctaIcon": "_3tJKsG_ctaIcon",
  "ctaText": "_3tJKsG_ctaText",
  "emeraldBanner": "_3tJKsG_emeraldBanner",
  "hide": "_3tJKsG_hide",
  "m2LiveBanner": "_3tJKsG_m2LiveBanner",
  "oneMore": "_3tJKsG_oneMore",
  "onlyDesktop": "_3tJKsG_onlyDesktop",
  "onlyMobile": "_3tJKsG_onlyMobile",
  "performanceLabBanner": "_3tJKsG_performanceLabBanner",
  "performanceLabBannerV2": "_3tJKsG_performanceLabBannerV2",
  "pulsomicsBanner": "_3tJKsG_pulsomicsBanner",
  "rotatingBanner": "_3tJKsG_rotatingBanner",
  "sddTwoHourBanner": "_3tJKsG_sddTwoHourBanner",
  "shippingBanner": "_3tJKsG_shippingBanner",
  "tile": "_3tJKsG_tile",
  "track": "_3tJKsG_track",
  "viewport": "_3tJKsG_viewport",
  "withDesktopCaret": "_3tJKsG_withDesktopCaret",
});
